module.exports = __webpack_public_path__ + "img/logo.fd61e04b.png";